module.exports = __webpack_public_path__ + "static/media/Leccion-5-7-El-Jugador-de-Equipo.34be39d8.pdf";